export default __webpack_public_path__ + "9c1b095a0ea4b62c3af26d2422bff0f4.png";